import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { RiDeleteBackLine } from 'react-icons/ri';

const SunFlash = () => {
    const ref = useRef();

    var time = 0;

    useFrame((_, delta) => {
        if (ref.current.position.x < 0.8) ref.current.position.x += 0.3 * delta;
        if (ref.current.position.y < -0.8)
            ref.current.position.y -= 0.3 * delta;
    });

    useFrame((_, delta) => {
        time += delta;

        if (ref.current.intensity > 0) ref.current.intensity -= 60 * delta;
    });

    return (
        <>
            <directionalLight
                position={[0, 0, -1]}
                target-position={[0, 0, 0]}
                intensity={300}
                color={'hsla(0, 100%, 72%, 1.00)'}
                castShadow={false}
                ref={ref}
            />
            {/* <ambientLight intensity={0.05} color={'#aabbcc'} /> */}
        </>
    );
};

export default SunFlash;
